import { TEAM_TYPES } from 'common/constants/constants';

export const filterAllContributors = teams =>
  teams.filter(({ type }) => type !== TEAM_TYPES.ALL_CONTRIBUTORS);

export const filterNotAllContributors = teams =>
  teams.filter(({ type }) => type === TEAM_TYPES.ALL_CONTRIBUTORS);

export const filterAllTeamsGroupAndAllContributors = teams =>
  teams.filter(
    ({ type }) =>
      type !== TEAM_TYPES.ALL_TEAMS && type !== TEAM_TYPES.ALL_CONTRIBUTORS
  );
